module.exports = __webpack_public_path__ + "static/media/efective_cyber_seurity_banner_design.124c4139.png";